import { FiSearch } from 'react-icons/fi';
import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';
export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  field: {
    leadingIcon: <FiSearch className="mr-5 h-6 w-6 bg-white text-muted-foreground" />,
    buttonVariant: 'ghost',
    inputWrapperClassName: 'border-e-none h-12 rounded-lg px-4 pr-1 ea-search-bar__input',
    buttonClassName: 'h-10 w-10 rounded-lg border-none bg-transparent p-0',
  },
};
